/**
 * Defines a Popper modifier that will set Popper's z-index based on the value
 * of `pvdZIndex`.
 */
function getZIndexPopperModifier() {
    return {
        name: 'zIndex',
        enabled: true,
        phase: 'beforeWrite',
        fn: modifier => {
            modifier.state.styles.popper['z-index'] = this.pvdZIndex;
        },
    };
}

export { getZIndexPopperModifier };
//# sourceMappingURL=get-z-index-popper-modifier.js.map
